var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardsIcon = function SvgDashboardsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3aacc8"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m20 9 9.5 5.5v11L20 31l-9.5-5.5v-11zm-7.67 6.56v8.88L20 28.89l7.67-4.45v-8.88L20 11.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.85 18.94 1.83-1.04v8.37l-.92.52-.91-.52zM23.81 15.54l-1.83-1.05v10.99l1.83-1.04zM15.72 21.82l1.82-1.05v4.71l-1.82-1.04z"
  }))));
};
export { SvgDashboardsIcon as ReactComponent };
export default __webpack_public_path__ + "b79c08bbbc63b335428003c9cc48bc36.svg";